import { userAPI } from "../../API/API";
import { LOGOUT_AUTH_USER, SET_AUTH_USER, SET_UPDATED_PASS } from "./constans";
import { setObjectsList } from "../../components/Objects/actions";
import { updateSavingStatus } from "../app/actions";

export const setAuthUser = (payload) => ({ type: SET_AUTH_USER, payload })

export const logoutAuthUser = () => ({ type: LOGOUT_AUTH_USER })

export const setUpdatedPass = () => ({ type: SET_UPDATED_PASS })


export const getUser = () => async (dispatch) => {

  const response = await userAPI.getUser();
  if (response.status) {
    //todo замена роли
    return dispatch(setAuthUser({ ...response.data })) //, role: "user"
  } else {
    dispatch(logoutUser())
  }
}

export const loginUser = (formValues) => async (dispatch) => {
  const response = await userAPI.login(formValues);
  if (response.status) {
    localStorage.setItem("egApiToken", response.data.hash)
    //todo замена роли
    return dispatch(setAuthUser({ ...response.data })) //, role: "user"
  } else {
    return response.data.message
  }
}

export const logoutUser = () => async (dispatch) => {
  localStorage.removeItem("egApiToken")
  const response = await userAPI.logout()
  if (response) {
    dispatch(logoutAuthUser())
    dispatch(setObjectsList())
  }
};

export const signUp = (form, type) => async (dispatch) => {
  const formData = { ...form }
  formData["type"] = type
  const utmSource = localStorage.getItem('utmSource')

  if (utmSource) {
    formData["utmSource"] = utmSource
  }

  const response = await userAPI.signUp(formData)
  if (response.status) {
    localStorage.setItem("egApiToken", response.data.hash)
    dispatch(getUser())
  }else{
    return response
  }
};

export const checkUserExist = (login, type) => async () => {
  const formData = { "login": login, "type": type };
  const response = await userAPI.checkUserExist(formData);

  if (!response.status) {
    return response.data
  }
};


export const saveUser = (data) => async (dispatch) => {
  const changePass = data.data.password && data.data.password;
  dispatch(updateSavingStatus({ status: "loading" }));

  const response = await userAPI.update(data);

  if (response.status) {
    dispatch(updateSavingStatus({ status: "success" }));
    await dispatch(setAuthUser(response.data));

    if (changePass) {
      return "logout"
    }

    return true

  } else {
    dispatch(updateSavingStatus({ status: "error", message: response.data.message }))
  }
};

export const updatedPass = () => async (dispatch) => {
  dispatch(setUpdatedPass())
};


export const confirmRegistration = (formData) => async (dispatch) => {

  let response = await userAPI.confirmRegistration(formData);
  if (response) {
    if (response.status) {
      localStorage.setItem("egApiToken", response.data.hash)
      dispatch(setAuthUser({ ...response.data }))
    }

    return response
  }
}

export const sendUserConfirmation = (formData) => async () => {
  await userAPI.sendUserConfirmation(formData);
}

export const passwordChangeRequest = (formData) => async () => {
  const response = await userAPI.passwordChangeRequest(formData)

  try {
    return response
  } catch (e) {
    return response
  }

}

export const changePassword = (formData) => async () => {
  const response = await userAPI.changePassword(formData)
  if (response.data) {
    return response
  }
}

export const getAccess2Object = (formData) => async () => {
  const response = await userAPI.getAccess2Object(formData)
  if (response.data) {
    return response.data
  }
}

export const getAccess2ObjectAuth = (formData) => async () => {
  const response = await userAPI.getAccess2ObjectAuth(formData)
  if (response.data) {
    return response.data
  }
}
